import {Dropzone} from "dropzone";
import {getValidationErrorForLargeUploads, resetFormErrors, showErrorsNextToInputs} from "../../../utils/form";
import {apiUrl} from "../../../utils/urlGenerator";
import * as notification from "../../notifications";

const initFormFieldFile = (dropzoneElement) => {
  const parentFormGroupElement = dropzoneElement.closest('.form-group');
  const parentElement = dropzoneElement.parent('.f_dropzone_parent');
  const fileModule = dropzoneElement.data('file-module');
  const fileUrl = dropzoneElement.data('file-url');
  const fileId = dropzoneElement.data('file-id');
  const hiddenFileInputName = `file_${fileId}`;
  const form = dropzoneElement.closest('form');
  let headers = {
    'X-CSRF-TOKEN': $("input[name='_token']", form).val() || window.$jBoard.csrf_token
  };

  const deleteTemporaryCustomFieldFile = (secretKey) => {
    if (fileModule !== 'CustomField' || !secretKey) {
      return $.Deferred().resolve().promise();
    }

    return $.ajax({
      url: apiUrl('/files/CustomField'),
      type: 'DELETE',
      headers,
      data: {secret_key: secretKey},
    });
  };

  const resetFileInput = () => {
    dropzone.removeAllFiles(true);
    $('.form-field-file-value', parentElement).val('');
    dropzoneElement.data('file-is-temporary', false);
    $('.file-preview', dropzoneElement).remove();
    $('.file-container', dropzoneElement).removeClass('d-none');
    dropzoneElement.addClass('dropzone-container');
    dropzoneElement.removeClass('dz-container-error');
    resetFormErrors(parentFormGroupElement);
  };

  if (window.$jBoard.currentSessionID) {
    headers = Object.assign(headers, { 'X-SESSION-ID': window.$jBoard.currentSessionID });
  }

  const options = {
    url: apiUrl("/files/" + fileModule),
    maxFiles: 1,
    headers,
    init: function () {
      this.on("maxfilesexceeded", function (file) {
        this.removeAllFiles();
        this.addFile(file);
      });
      this.on("success", function (file, response) {
        const previousSecretKey = $('.form-field-file-value', parentElement).val();
        const previousFileIsTemporary = dropzoneElement.data('file-is-temporary');

        $('.form-field-file-value', parentElement).val(response.secret_key);
        dropzoneElement.data('file-is-temporary', Boolean(response.is_temporary));
        $('.dz-download', parentElement).attr('href', response.url);
        resetFormErrors(parentFormGroupElement);
        dropzoneElement.removeClass('dz-container-error');

        if (previousFileIsTemporary && previousSecretKey && previousSecretKey !== response.secret_key) {
          deleteTemporaryCustomFieldFile(previousSecretKey).fail(function () {
            notification.danger('Could not remove the previous file. Please try again.');
          });
        }
      });
      this.on("error", function (file, uploadError) {
        if (uploadError === 'dictMaxFilesExceeded') {
          return;
        }

        const fileInputName = $('.form-field-file-value', parentElement).attr('name');
        /**
         * Array-style names ("custom_fields[123][value]") are not valid jQuery
         * selectors; convert to the dotted error key ("custom_fields.123.value")
         * so showErrorsNextToInputs resolves the input by its #v-... id.
         * Plain names ("resume") stay unchanged.
         */
        const fileInputErrorKey = fileInputName.replace(/\[([^\]]+)\]/g, '.$1');

        let error = uploadError;
        if(typeof uploadError === 'object') {
          error = {
            ...uploadError,
            errors: {
              [fileInputErrorKey]: uploadError.errors["file"]
            }
          };
        }

        dropzoneElement.addClass('dz-container-error');

        const response = getValidationErrorForLargeUploads(error, hiddenFileInputName);
        this.removeAllFiles();

        /**
         * Errors are appended to the field's form group, so clear them there -
         * otherwise every failed upload stacks another message under the field.
         */
        resetFormErrors(parentFormGroupElement);

        if (typeof response.errors !== 'undefined') {
          showErrorsNextToInputs(form, response);
        } else if (typeof response.message !== 'undefined') {
          notification.danger(response.message);
        } else {
          showErrorsNextToInputs(form, {
            errors: {
              [hiddenFileInputName]: [error]
            },
          });
        }
      });
    },
    previewTemplate: $(".dropzone-preview-template", parentElement).html(),
    dictMaxFilesExceeded: 'dictMaxFilesExceeded',
  };

  for (let optionKey in window.$dropzoneOptions[fileId]) {
    options[optionKey] = window.$dropzoneOptions[fileId][optionKey];
  }

  $('.upload-another-file', dropzoneElement).click(function (e) {
    e.stopPropagation();
    $('.file-container', dropzoneElement).removeClass('d-none');
    dropzoneElement.addClass('dropzone-container')
    $('.file-preview', dropzoneElement).remove();

    return false;
  });

  $('.file-url', dropzoneElement).click(function (e) {
    e.stopPropagation();
    location.href = fileUrl;
  });

  let dropzone = new Dropzone(dropzoneElement.get(0), options);

  $(".btn-choose-file", dropzoneElement).click(function () {
    dropzone.hiddenFileInput.click();

    return false;
  });

  /**
   * "Remove file" clears the submitted value, so saving the form deletes the
   * stored file reference. Delegated: the link lives both in the server-rendered
   * preview and in dynamically added dropzone previews.
   */
  $(parentElement).on('click', '.remove-uploaded-file', function (e) {
    e.stopPropagation();

    const secretKey = $('.form-field-file-value', parentElement).val();
    if (dropzoneElement.data('file-is-temporary') && secretKey) {
      deleteTemporaryCustomFieldFile(secretKey)
        .done(resetFileInput)
        .fail(function () {
          notification.danger('Could not remove the file. Please try again.');
        });
    } else {
      resetFileInput();
    }

    return false;
  });
};

$(function () {
  $('.form-field-file-container').each(function () {
    initFormFieldFile($(this));
  });
});
